export default "__VITE_ASSET__OSuT69u4__"